<div class="login-container">
  <div class="login-card">
    <div class="text-center mb-4">
      <img src="assets/images/Logo Khipure.png" alt="Khipure" class="login-logo mb-3">
      <h4 class="subtitle">Panel Administrativo</h4>
      <p class="text-muted">Operaciones SaaS</p>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="email" class="form-label"><i data-feather="mail"></i> Email</label>
        <input type="email" class="form-control" id="email" formControlName="email"
          placeholder="admin@khipure.com" [class.is-invalid]="email?.invalid && email?.touched" />
        <div class="invalid-feedback" *ngIf="email?.invalid && email?.touched">
          <span *ngIf="email?.errors?.['required']">El email es requerido</span>
          <span *ngIf="email?.errors?.['email']">Email inválido</span>
        </div>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label"><i data-feather="lock"></i> Contraseña</label>
        <input type="password" class="form-control" id="password" formControlName="password"
          placeholder="••••••••" [class.is-invalid]="password?.invalid && password?.touched" />
        <div class="invalid-feedback" *ngIf="password?.invalid && password?.touched">
          <span *ngIf="password?.errors?.['required']">La contraseña es requerida</span>
          <span *ngIf="password?.errors?.['minlength']">Mínimo 6 caracteres</span>
        </div>
      </div>
      <button type="submit" class="btn btn-primary w-100 btn-lg" [disabled]="loading">
        <span *ngIf="!loading"><i data-feather="log-in"></i> Iniciar Sesión</span>
        <span *ngIf="loading">
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Iniciando sesión...
        </span>
      </button>
      <div class="mt-3 text-center">
        <a href="#" class="text-decoration-none text-primary" (click)="onForgotPassword($event)">
          <small><i data-feather="help-circle"></i> ¿Olvidaste tu contraseña?</small>
        </a>
      </div>
      <div class="mt-2 text-center">
        <small class="text-muted">Acceso restringido. Solicita tu habilitación al administrador de Khipure.</small>
      </div>
    </form>
    <div class="text-center mt-4">
      <small class="text-muted">© 2026 Khipure. Todos los derechos reservados.</small>
    </div>
  </div>
</div>
